import { useMutation, useQueryClient } from '@common-fe/common-fe';

import { api } from '@/api';
import { RequestHeaders } from '@/common/constants';
import { API_URL } from '@/dtos';

import { TaxType } from '../../Contributions/contributions.types';

import { GET_CONTRIBUTION_ACTIVITIES_QUERY_KEY } from './useGetContributionActivities.query';

interface PayloadData {
  ee_amount?: number;
  er_amount?: number;
  date?: string;
  tax_year?: string;
  tax_type?: TaxType;
  memo?: string;
}

export const useUpdateAllContributionRecordsSameValuesQuery = (
  requestId?: string,
  requestVersion?: number,
  onSuccess?: () => void,
  onError?: (errorText?: string) => void
) => {
  const queryClient = useQueryClient();

  const { mutateAsync, isLoading, isSuccess } = useMutation(
    async (data?: PayloadData) =>
      api.patch(
        API_URL.CONTRIBUTIONS_CONTRIBUTION_REQUESTS_CONTRIBUTION_RECORDS_UPDATE_ALL_BY_REQUEST_ID(
          requestId || ''
        ),
        data,
        {
          headers: {
            [RequestHeaders.ifMatch]: requestVersion,
          },
        }
      ),
    {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [GET_CONTRIBUTION_ACTIVITIES_QUERY_KEY],
        });
        if (onSuccess) onSuccess();
      },
      /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
      onError: (error: any) => {
        onError?.(error?.response?.data?.elevate_error_message);
      },
    }
  );

  return {
    updateAllContributionRecordsSameValues: mutateAsync,
    isLoading,
    isSuccess,
  };
};
